import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Anexo, GetAnexoByIDResponse, PostAnexosTemporalesResponse } from '../models/Anexo';
import { TramitePortal } from '../models/Document';

@Injectable({
  providedIn: 'root'
})
export class AnexoService {

  private DELETE_ANEXO_URL = environment.apiUrl + "/anexo/"
  private POST_ANEXOS_TEMPORALES_URL = environment.apiUrl + "an/adj/sub"
  private LIST_ANEXOS_BY_DOCUMENTID = environment.apiUrl + "an/d/"
  private GET_ANEXO_BY_ID = environment.apiUrl + "an/"
  private GET_ANEXO_TEMPORAL_BY_ID = environment.apiUrl + "an/temp/"

  constructor(
    private http: HttpClient,
  ) { }

  get(id: number): Observable<any> {
    return this.http.get(environment.apiUrl + "an/" + id, { responseType: 'blob' });
  }

  getAnexoByID(id: number, estatus: string): Observable<GetAnexoByIDResponse> {
    let url = ""
    if (estatus === "ADJ") {
      url = this.GET_ANEXO_BY_ID + id
    }
    if (estatus === "TMP") {
      url = this.GET_ANEXO_TEMPORAL_BY_ID + id
    }
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map((response) => {
        const contentDisposition = response.headers.get('Content-Disposition') || '';
        const filename = this.extractFilename(contentDisposition) || `anexo_${id}`;

        return {
          blob: response.body as Blob,
          filename: filename
        };
      })
    );
  }

  private extractFilename(contentDisposition: string): string | null {
    if (!contentDisposition) {
      return null;
    }

    // Soporta filename*=UTF-8''archivo.pdf
    const filenameStarMatch = /filename\*\s*=\s*([^;]+)/i.exec(contentDisposition);
    if (filenameStarMatch?.[1]) {
      const encodedValue = filenameStarMatch[1].trim().replace(/^UTF-8''/i, '').replace(/^"|"$/g, '');
      try {
        return decodeURIComponent(encodedValue);
      } catch {
        return encodedValue;
      }
    }

    const filenameMatch = /filename\s*=\s*([^;]+)/i.exec(contentDisposition);
    if (!filenameMatch?.[1]) {
      return null;
    }

    return filenameMatch[1].trim().replace(/^"|"$/g, '');
  }


  /**
   * Obtiene el listado de anexos de un documento
   * @param id id del documento
   * @returns Observable
   */
  getByDocument(id: number): Observable<any> {
    return this.http.get(environment.apiUrl + "an/d/" + id);
  }

  /**
   * Obtiene el listado de anexos de un documento
   * @param id id del documento
   * @returns Observable
   */
  getById(id: String): Observable<TramitePortal> {
    return this.http.get<TramitePortal>(environment.apiUrl + "an/e/" + id);
  }

  listAnexosByDocumentID(id: number): Observable<Anexo[]> {
    return this.http.get<Anexo[]>(this.LIST_ANEXOS_BY_DOCUMENTID + id)
  }

  /**
   * Consulta el documento correspondiente a la tarea enviada
   * @param id Id de tarea
   * @returns Id de anexo
   */
  getDocumentByIdTarea(id: number): Observable<Anexo> {
    return this.http.get(environment.apiUrl + "an/od/" + id);
  }

  getAnexosRamal(id: number): Observable<Anexo[]> {
    return this.http.get<Anexo[]>(environment.apiUrl + "an/r/" + id);
  }

  postAnexosTemporales(anexo: Anexo): Observable<Anexo[]> {
    const formData: FormData = new FormData();

    anexo.file!.forEach((file) => {
      formData.append('file', file, file.name);
    });

    if (anexo.desc) {
      formData.append('desc', anexo.desc);
    }

    return this.http.post<Anexo[]>(this.POST_ANEXOS_TEMPORALES_URL, formData);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.DELETE_ANEXO_URL + id.toString())
  }
}
